import React, { FunctionComponent, useState } from "react";
import { LinearProgress, Stack } from "@mui/material";
import { RightDetailListItem } from "../../RightDetailListItem";
import styles from "./styles.module.scss";
import { useCurrencyFormatter } from "../../../hooks/currencyFormatter";
import { ProductType } from "../../../hooks/products/interfaces";
import { ProductPurchasesDialog } from "../../products/ProductPurchasesDialog";
import { productIconMap } from "../../../models/ProductUtilities";
import { IconType } from "../../../icons";

export const ResourceLimitListItem: FunctionComponent<IResourceLimitListItemProps> = ({
  productType,
  title,
  currentAmount,
  totalAmount,
  detailBlurred
}) => {
  const [isPurchaseDialogOpen, setIsPurchaseDialogOpen] = useState(false);
  const currencyFormatter = useCurrencyFormatter();
  const barColor = () => {
    if (currentAmount >= totalAmount) return "error";
    if (totalAmount - currentAmount < totalAmount * 0.1) return "warning";
    return undefined;
  };
  return (
    <>
      <RightDetailListItem
        iconType={productIconMap[productType]}
        title={title}
        detailBlurred={detailBlurred}
        detail={
          <Stack direction={"column"} spacing={0.5} alignItems={"center"}>
            <Stack direction={"row"} spacing={1}>
              <p style={{ fontWeight: "normal", fontVariant: "tabular-nums" }}>
                {currencyFormatter.decimalFormat(currentAmount)}
              </p>
              <p style={{ fontWeight: "normal" }}>/</p>
              <p style={{ fontVariant: "tabular-nums" }}>
                {totalAmount >= 99_999_999 ? "∞" : currencyFormatter.decimalFormat(totalAmount)}
              </p>
            </Stack>
            <LinearProgress
              className={styles.bar}
              variant={"determinate"}
              value={(currentAmount / totalAmount) * 100}
              color={barColor()}
            />
          </Stack>
        }
        rightIconType={IconType.ChevronRight}
        onClick={() => setIsPurchaseDialogOpen(true)}
      />
      <ProductPurchasesDialog
        open={isPurchaseDialogOpen}
        setOpen={setIsPurchaseDialogOpen}
        productType={productType}
      />
    </>
  );
};

export interface IResourceLimitListItemProps {
  productType: ProductType;
  title: string;
  currentAmount?: number;
  totalAmount?: number;
  detailBlurred: boolean;
}
